import DataSource from "../DataSource/DataSource";

export default class OdberneMiestoService {
  constructor(server, FileService, KontaktService){
    this.server = server;
    this.FileService = FileService;
    this.KontaktService = KontaktService;
  }
 
  get(id){
    return this.server("odbernemiesto.get", {id: id});
  }

  getForSamoodpocet(id){
    return this.server("odbernemiesto.get.samoodpocet", {id: id});
  }

  saveItem(id, item){
    return this.server("odbernemiesto.update", {id: id, data: item});
  }

  create(kontaktId){
    return this.get(0).then(om => this.KontaktService.get(kontaktId).then(kontakt => ({
      ...om,
      kontakt
    })));
  }

  listSource(){
    return new DataSource(this.server, "odbernemiesto.list.source");
  }

  listOpravnenaOsoba() {
    var temp = new DataSource(this.server, "odbernemiesto.list.opravnena.osoba");
    console.log('listOpravnenaOsoba response debug');
    console.log(temp.result);
    return temp;
  }

  save(id, item){
    return this.server("odbernemiesto.import", {id: id, data: item});
  }

  batch(data){
    return this.server("odbernemiesto.batch", {data: data});
  }

  readXlsPlyn(file){
    return this.FileService.read(file).then(file => this.server("odbernemiesto.xls.plyn.read", {file: file}));
  }

  importXlsRk(file){
    return this.FileService.read(file).then(file => this.server("odbernemiesto.import.xlsrk", {file: file}));
  }

  createXMLBilancnaSkupina(platnostOd, platnostDo) {
    return this.server("odbernemiesto.xml.create.bilancna.skupina", {platnostOd: platnostOd, platnostDo: platnostDo});
  }

  importXlsDk(file){
    return this.FileService.read(file).then(file => this.server("odbernemiesto.import.xlsdk", {file: file}));
  }

  orderRk(zmenaRk){
    return this.server("odbernemiesto.rk.order", {zmenaRk: zmenaRk});
  }

  orderDkBatch(orders){
    return this.server("odbernemiesto.dk.order.batch", {orders: orders});
  }

  orderRkBatch(orders){
    return this.server("odbernemiesto.rk.order.batch", {orders: orders});
  }

  exportRk(){
    window.open(this.server.getRequestUrl("odbernemiesto.export.rk.my"));
  }

  exportDk(){
    window.open(this.server.getRequestUrl("odbernemiesto.dk.export.my"));
  }

  exportSamoodpocet(typOM){
    window.open(this.server.getRequestUrl("meradlo.samoodpocet.export.my", {typOM: typOM}));
  }

  exportXlsPlyn(){
    window.open(this.server.getRequestUrl("odbernemiesto.xls.plyn.export"));
  }

  readRkXls(file){
    return this.FileService.read(file).then(file => this.server("odbernemiesto.read.rk.xls", {file: file}));
  }

  readDkXls(file){
    return this.FileService.read(file).then(file => this.server("odbernemiesto.dk.read", {file: file}));
  }

  getOpmStatuses() {
    return this.server("odbernemiesto.get.statuses.all", {});  
  }

}


// WEBPACK FOOTER //
// ./src/OdberneMiesto/OdberneMiestoService.js